import { Link } from "react-router-dom";
import { Flag } from "lucide-react";

/* Small "Report a correction" link that pre-fills the reference on the contact form. */
export function ReportCorrection({ reference, className = "", testId = "report-correction-link" }) {
  return (
    <Link to={`/contact?topic=correction&ref=${encodeURIComponent(reference)}`} data-testid={testId}
      className={`inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-muted-foreground transition-colors hover:text-foreground ${className}`}>
      <Flag className="h-3 w-3 text-gold" /> Report a correction
    </Link>
  );
}
